<template>
  <!-- 外层容器 -->
  <div
    class="relative flex flex-col items-between w-full h-[48.38vw] py-[3.75vw]"
  >
    <el-image
      class="absolute top-0 left-0 w-full h-full"
      :src="backgroundImage"
      lazy
      fit="cover"
      style="object-position: center"
    ></el-image>
    <!-- 容器区域1 -->
    <div
      class="relative flex mt-[1.4vw] w-[61.46vw] h-auto mx-auto my-auto gap-[5.2vw]"
    >
      <!-- 图片容器 -->
      <div class="w-[24.63vw] h-[23.85vw] flex items-center flex-shrink-0">
        <el-image
          class="w-full h-full object-center object-cover"
          :src="`https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-study/competition/module2/sample2.png`"
          lazy
        />
      </div>

      <!-- 文字容器 -->
      <div class="flex flex-col w-auto h-full justify-between">
        <div
          v-for="(block, index) in textBlocks"
          :key="index"
          class="flex flex-col gap-[0.87vw]"
          :class="index === 1 ? 'ml-[5.42vw]' : ''"
        >
          <div
            class="flex w-[18.75vw] h-[2.02vw] rounded-l-[2.02vw] bg-gradient-to-r from-[#80e0ff] via-[#4985f9] to-[#3d77ff]/0"
          >
            <p
              class="flex ml-[1.28vw] my-auto text-[0.94vw] text-[#FFFFFF] font-harmony font-bold"
            >
              {{ block.title }}
            </p>
          </div>
          <p
            class="w-[28.65vw] text-[0.83vw] text-[#5F6468] font-harmony font-normal"
            style="text-align: justify; text-justify: inter-ideograph"
          >
            {{ block.content }}
          </p>
        </div>
      </div>
    </div>

    <!-- 容器区域2 -->
    <div
      class="relative flex justify-between mb-[0.57vw] w-[61.46vw] h-auto mx-auto my-auto gap-[0.83vw]"
    >
      <!-- 使用 v-for 循环动态渲染文字容器 -->
      <div
        v-for="(item, index) in items"
        :key="index"
        class="flex flex-1 justify-center items-center bg-[#FFFFFF]"
      >
        <div
          class="flex flex-col justify-center items-center gap-[0.42vw] py-[0.42vw]"
        >
          <div class="text-[1.88vw] text-[#1C9AF3] font-rubik font-medium">
            {{ item.mainTitle }}
          </div>
          <div class="text-[0.94vw] text-[#1A2233] font-harmony font-normal">
            {{ item.subTitle }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "competition-module2",
  data() {
    return {
      backgroundImage: `https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-study/competition/module2/sample1.png`,
      items: [
        {
          mainTitle: "6-18岁",
          subTitle: "年龄",
        },
        {
          mainTitle: "100000+",
          subTitle: "历届参赛人数",
        },
        {
          mainTitle: "2017",
          subTitle: "创办时间",
        },
        {
          mainTitle: "2020至今",
          subTitle: "连续参赛",
        },
      ],
      textBlocks: [
        {
          title: '"飞北"赛',
          content:
            "“飞向北京·飞向太空”全国青少年航空航天模型教育竞赛活动，是一项有30余年历史的航空航天模型教育品牌活动。",
        },
        {
          title: "全国青少年航空航天模型锦标赛",
          content:
            "全国青少年无人机大赛是由中国航空学会主办的面向全国中小学生的无人机专项创新赛事，自 2017 年开始举办，历届大赛总参赛人数累计逾10万人次，2020 年起连续入选教育部赛事活动 “白名单”。",
        },
        {
          title: "全国青少年无人机大赛",
          content:
            "全国青少年航空航天模型锦标赛是由国家体育总局航空无线电模型运动管理中心、中国航空运动协会主办的赛事，是国内最高级别的青少年航空航天模型比赛之一。",
        },
      ],
    };
  },
};
</script>

<style scoped>
.bg-gradient-to-t {
  background-image: linear-gradient(
    to top,
    rgba(255, 255, 255, 1),
    rgba(255, 255, 255, 0)
  );
  height: 5vw; /* 增加虚化高度 */
}
</style>